/**
 * Shared-cart loader.
 * Loaded (deferred) whenever enable_share_cart is on. Exits immediately unless
 * ?share_cart= is in the URL, so normal browse/checkout is unaffected.
 * Client-side detection is required because CDN-cached pages may not include
 * Liquid branches that depend on the query string.
 */
(function () {
  if (window.__banyanShareCartLoaded) return;
  window.__banyanShareCartLoaded = true;

  var SHARE_PARAM = 'share_cart';
  var ADD_BATCH_SIZE = 50;
  var config = window.__banyanShareCartConfig || {};

  function getShareValue() {
    try {
      return new URLSearchParams(window.location.search).get(SHARE_PARAM);
    } catch (error) {
      return null;
    }
  }

  // Fast exit for every page that is not a shared-cart link.
  var shareValue = getShareValue();
  if (!shareValue) return;

  function toJsEndpoint(url, fallback) {
    var value = String(url || fallback || '');
    if (!value) return fallback;
    if (/\.js(\?|$)/.test(value)) return value;
    return value.replace(/\/$/, '') + '.js';
  }

  function getCartClearUrl() {
    var cartUrl = config.cartUrl || (window.routes && window.routes.cart_url) || '/cart';
    return String(cartUrl).replace(/\/$/, '') + '/clear.js';
  }

  function getCartAddUrl() {
    return toJsEndpoint(
      config.addUrl || (window.routes && window.routes.cart_add_url),
      '/cart/add.js'
    );
  }

  function getCheckoutUrl() {
    var root = config.rootUrl;
    if (root == null) {
      root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
        (window.routes && window.routes.root) ||
        '/';
    }
    return (String(root) === '/' ? '' : String(root).replace(/\/$/, '')) + '/checkout';
  }

  function parseShareCartItems(value) {
    if (!value) return [];

    return value
      .split(',')
      .map(function (part) {
        var bits = part.split(':');
        var id = Number(bits[0]);
        var quantity = Number(bits[1]) || 1;
        var sellingPlan = Number(bits[2]) || 0;
        if (!id || quantity < 1) return null;

        var item = { id: id, quantity: quantity };
        if (sellingPlan > 0) item.selling_plan = sellingPlan;
        return item;
      })
      .filter(Boolean);
  }

  function chunk(items, size) {
    var groups = [];
    for (var i = 0; i < items.length; i += size) {
      groups.push(items.slice(i, i + size));
    }
    return groups;
  }

  function ensureLoadingStyles() {
    if (document.getElementById('banyan-share-cart-style')) return;
    var style = document.createElement('style');
    style.id = 'banyan-share-cart-style';
    style.textContent =
      'html.share-cart-loading,html.share-cart-loading body{cursor:wait;}' +
      'html.share-cart-loading body{overflow:hidden;}' +
      'html.share-cart-loading body::before{content:"";position:fixed;inset:0;z-index:99998;background:rgba(255,255,255,.7);}' +
      'html.share-cart-loading body::after{content:"Loading shared cart…";position:fixed;top:50%;left:50%;z-index:99999;' +
      'transform:translate(-50%,-50%);padding:1.2rem 1.6rem;border-radius:.4rem;background:#fff;' +
      'box-shadow:0 .4rem 1.6rem rgba(0,0,0,.12);font-size:1.4rem;font-family:system-ui,sans-serif;}';
    document.head.appendChild(style);
  }

  function readJson(response) {
    return response.text().then(function (text) {
      if (!text) return null;
      try {
        return JSON.parse(text);
      } catch (error) {
        return null;
      }
    });
  }

  function isAddError(response, payload) {
    if (!response.ok) return true;
    // Shopify error payloads use a numeric status (e.g. 422) plus message/description.
    if (payload && typeof payload.status === 'number' && payload.status >= 400) return true;
    return false;
  }

  function fail(message) {
    window.__banyanShareCartLoading = false;
    document.documentElement.classList.remove('share-cart-loading');
    window.alert(message || 'Sorry, we could not load this shared cart. Please try again.');
  }

  function loadSharedCart() {
    if (window.__banyanShareCartLoading) return;

    var items = parseShareCartItems(shareValue);
    if (!items.length) {
      fail('This shared cart link is invalid or empty.');
      return;
    }

    window.__banyanShareCartLoading = true;
    ensureLoadingStyles();
    document.documentElement.classList.add('share-cart-loading');

    var addUrl = getCartAddUrl();
    var batches = chunk(items, ADD_BATCH_SIZE);

    fetch(getCartClearUrl(), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .catch(function () {
        return null;
      })
      .then(function () {
        return batches.reduce(function (chain, batch) {
          return chain.then(function () {
            return fetch(addUrl, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              credentials: 'same-origin',
              body: JSON.stringify({ items: batch }),
            }).then(function (response) {
              return readJson(response).then(function (payload) {
                if (isAddError(response, payload)) {
                  throw new Error(
                    (payload && (payload.description || payload.message)) ||
                      'Add failed'
                  );
                }
              });
            });
          });
        }, Promise.resolve());
      })
      .then(function () {
        // replace() avoids re-running this loader if the shopper hits Back from checkout
        window.location.replace(getCheckoutUrl());
      })
      .catch(function (error) {
        console.error('Shared cart error', error);
        fail('Sorry, we could not load this shared cart. Please try again.');
      });
  }

  loadSharedCart();
})();
